import { SET_COMMON_DATA } from "./CommonTypes";

export function setCommonData(data:object){
    return {type:SET_COMMON_DATA, payload:{...data}} 
}
